import React, { ReactElement } from 'react';
import { ChevronDown } from '@assets/images';
import { GenerateCertificateDropdownButton } from '../styles';

type MenuButtonI = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isOpened?: boolean;
  icon?: ReactElement;
  label?: string;
  'data-testid'?: string;
};

const generateCertificateDropdownMenuButton = React.forwardRef<
  HTMLDivElement,
  MenuButtonI
>((props, ref) => {
  const { onClick, isOpened } = props;

  return (
    <div ref={ref}>
      <GenerateCertificateDropdownButton
        isOpened={isOpened}
        onClick={(event) => {
          event.preventDefault();
          onClick(event);
        }}
      >
        <ChevronDown />
      </GenerateCertificateDropdownButton>
    </div>
  );
});

export default generateCertificateDropdownMenuButton;
